import { MenuItem } from "@chakra-ui/react";
import { feeInformationToCreation } from "features/fees/FeeUtils";
import { ReadOnlyFeeForm } from "features/fees/form/ReadOnlyFeeForm";
import { useFeeInformationByFeeListSuspense } from "gen/endpoints/fee-information/fee-information";
import { useInvestorClassRetrieveSuspense } from "gen/endpoints/investor-class/investor-class";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Restricted } from "shared/components/access/Restricted";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageMenu } from "shared/components/layout/PageMenu";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentClassFeePage: React.FC = () => {
  const { t } = useTranslation(["fees", "common", "enums"]);
  const navigate = useNavigate();

  const { fundFamilyId, investorClassId, feeId } = useRequiredStringParams();

  const { data: investorClassData } = useInvestorClassRetrieveSuspense(
    fundFamilyId,
    investorClassId,
  );

  const { data: feeData } = useFeeInformationByFeeListSuspense(
    fundFamilyId,
    feeId,
    {
      investor_class_id: investorClassId,
    },
    { query: { select: feeInformationToCreation } },
  );

  return (
    <PageContent contentWidth="boxed">
      <PageHeader
        title={feeData.fee.name}
        backButton={{
          title: t("common:fees"),
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .classes({ investorClassId: investorClassData.id }).$,
        }}
        actions={
          <Restricted permission={PermissionTypeEnum.config}>
            <PageMenu>
              <MenuItem
                onClick={() =>
                  navigate(
                    rootRoute({})
                      .fundFamilies({})
                      .fundFamily({ fundFamilyId })
                      .setup({})
                      .classes({})
                      .feeOverride({ investorClassId, feeId }).$,
                  )
                }
              >
                {t("common:edit")}
              </MenuItem>
            </PageMenu>
          </Restricted>
        }
      />
      <PageBody>
        <ReadOnlyFeeForm fundFamilyId={fundFamilyId} feeData={feeData} />
      </PageBody>
    </PageContent>
  );
};
